import React from 'react';
import { t } from '../locales/i18n';
import { tinyDate, parseISO } from '../utils/date-utils';
import styled from 'styled-components';
import { Queue } from '../types/queue';
import { colors } from '@nextinq/ui-toolkit';

const Container = styled.section<{ color: string }>`
  color: ${(p) => p.color};
`;

export interface QueueStateProps {
  queue: Queue;
  showDetail?: boolean;
}

export function QueueState(props: QueueStateProps) {
  const { queue } = props;

  const color = queue.status === 'open' ? colors.base.primary : colors.status.error;
  if (queue.lockedManually) {
    const lockDate = tinyDate(parseISO(queue.manualHandlingLockUntil));
    const key = queue.status === 'open' ? 'queueStatus.openManually' : 'queueStatus.closedManually';

    return (
      <Container color={color}>
        <h5>{t(key)}</h5>
        {props.showDetail && <h6>{t('queueStatus.manualLockDetail', { lockDate })}</h6>}
      </Container>
    );
  }
  const key = queue.status === 'open' ? 'queueStatus.openByCalendar' : 'queueStatus.closedByCalendar';
  return (
    <Container color={color}>
      <h5>{t(key)}</h5>
    </Container>
  );
}
